import * as React from 'react';

import { WalkScoreViewModel } from 'src/common/models';

import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutColumnsNoBreak } from 'uitk-react-layout-columns';

import { WalkScore } from 'components/infosite/whats-around/internals/walk-score';

interface NearbyListProps {
  outerClass?: string;
  title?: string;
  category?: string;
  accessibleCategory?: string;
  walkScoreModel?: WalkScoreViewModel;
}

export const NearbyList: React.FunctionComponent<NearbyListProps> = ({
  title,
  outerClass,
  category,
  accessibleCategory,
  walkScoreModel,
  children
}) => {
  if (!title) {
    return null;
  }

  return (
    <UitkLayoutColumnsNoBreak>
      <div className={`${outerClass} uitk-flex uitk-flex-row`}>
        {category && (
          <UitkIcon id={`${category}__heading-icon`} name={category} title={accessibleCategory || null} className="all-r-margin-three" />
        )}
        <div>
          <h4 className="uitk-type-heading-500">{title}</h4>
          <WalkScore model={walkScoreModel} />
          <div className="all-t-margin-two">{children}</div>
        </div>
      </div>
    </UitkLayoutColumnsNoBreak>
  );
};

NearbyList.displayName = 'NearbyList';
